// extracted by mini-css-extract-plugin
export var downArrow = "_7g-0";
export var infoTooltipIcon = "_7g-3";
export var label = "_7g-1";
export var optionCard = "_7g-4";
export var upArrow = "_7g-2";